import { useEffect } from 'react';
import { UserLanguagesResponse } from 'src/api/me/types';
import { getLanguagePair } from 'src/utils/language/getLanguagePair';
import { getLocalStorageEntry } from 'src/utils/webStorageUtils';
import { LANGUAGE_PAIR_ID } from 'src/utils/language/saveLastLanguagePair';
import { ROUTES } from '../constants/routes.const';
import useSafePush from './useSafePush';

export const useGetSavedPath = (
  userLanguagesData: UserLanguagesResponse | undefined,
  saveLastLanguagePairId: (filterLanguagePairId: number, source?: string, target?: string) => void,
) => {
  const { safePush } = useSafePush();
  useEffect(() => {
    if (!userLanguagesData) return;
    if (userLanguagesData.languagePairs?.length === 0) {
      void safePush(ROUTES.languages);
    } else {
      const rawSavedLanguagePairId = getLocalStorageEntry(LANGUAGE_PAIR_ID);

      const savedLanguagePairId = rawSavedLanguagePairId
        ? parseInt(rawSavedLanguagePairId)
        : undefined;

      const languagePair = getLanguagePair(userLanguagesData, savedLanguagePairId);

      const filterLanguagePairId = languagePair?.languagePairId;

      /* istanbul ignore next: unreachable as there's an empty array check above, necessary for typescript to rule out undefined */
      if (!filterLanguagePairId) {
        throw new Error('Language pair id is not available');
      }

      saveLastLanguagePairId(
        filterLanguagePairId,
        languagePair?.sourceLanguageLocale,
        languagePair?.targetLanguageLocale,
      );
    }
    // Not including router because of infinite loop issue
    // https://github.com/vercel/next.js/issues/18127
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveLastLanguagePairId, userLanguagesData]);
};
